<template>
  <div class="theme-layout">
    <header class="header2">
      <div class="topbar">
        <div class="container">
          <div class="header-timer">
            <p>Every Friday @11:00pm to 01:00am: Marathon Prayers</p>
            <ul class="headercounter">
              <li>
                <span class="days">00</span>
                <p class="days_ref">DAYS</p>
              </li>
              <li>
                <span class="hours">00</span>
                <p class="hours_ref">HOURS</p>
              </li>
              <li>
                <span class="minutes">00</span>
                <p class="minutes_ref">MINTS</p>
              </li>
              <li>
                <span class="seconds">00</span>
                <p class="seconds_ref">SECS</p>
              </li>
            </ul>
          </div>
          <p><i class="fa fa-mobile"></i> Mobile: 07723 363 184</p>
          <!--- CONTACT -->
          <p>
            <i class="fa fa-envelope"></i> info@christlifefaithministries.org
          </p>
          <!--- EMAIL -->
          <ul class="social-media">
            <li>
              <a
                title="CHRISTLIFE FAITH MINISTRIES Facebook"
                href="https://www.facebook.com/christlifefaithministries.org"
                target="_blank"
              >
                <i class="fa fa-facebook"></i>
              </a>
            </li>
            <li>
              <a
                title="CHRISTLIFE FAITH MINISTRIES YouTube"
                href="https://www.youtube.com/@christlifefaithministriesc5100/streams"
                target="_blank"
              >
                <i class="fa fa-youtube"></i>
              </a>
            </li>
            <!-- <li>
              <a title href="javascript:void(0);">
                <i class="fa fa-linkedin"></i>
              </a>
            </li>
            <li>
              <a title href="javascript:void(0);">
                <i class="fa fa-google-plus"></i>
              </a>
            </li> -->
          </ul>
          <!-- <div @click="redirectToShop" class="cart-dropdown">
            <p>
              <i class="fa fa-shopping-cart"></i>
              {{ basketCount }} item(s) -
              <span>$ {{ basketTotal }}</span>
            </p>
          </div> -->
        </div>
      </div>
      <!--- TOP BAR -->
      <nav class="style1">
        <div class="container">
          <div class="logo">
            <router-link to="/" :exact="true">
              <img
                src="/dist/assets/logos/cfmchurch_logo_hr_001.png"
                alt="CHRISTLIFE FAITH MINISTRIES LOGO"
              />
            </router-link>
          </div>
          <!--- LOGO -->
          <ul>
            <li
              v-if="isCoventryAdmin || isLeicesterAdmin"
              class="menu-item-has-children"
            >
              <a href="javascript:void(0);" title>Admin</a>
              <ul>
                <li v-if="isLeicesterAdmin" class="menu-item-has-children">
                  <a href="javascript:void(0);" title>CFM-Leicester</a>
                  <ul>
                    <!-- <li>
                      <router-link to="/shop-products-admin"
                        >Cash Orders</router-link
                      >
                    </li> -->
                    <li>
                      <router-link to="/leicester-resources"
                        >Manage Products</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/leicester-people"
                        >Manage People</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/leicester-events"
                        >Manage Events</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/leicester-addresses"
                        >Manage Addresses</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/leicester-alerts"
                        >Information Alert</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/donation-admin"
                        >Manage Donation Info</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li v-if="isCoventryAdmin" class="menu-item-has-children">
                  <a href="javascript:void(0);" title>Coventry</a>
                  <ul>
                    <li>
                      <router-link to="/toronto-resources"
                        >Manage Products</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/toronto-people"
                        >Manage People</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/toronto-events"
                        >Manage Events</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/toronto-addresses"
                        >Manage Addresses</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/toronto-alerts"
                        >Information Alert</router-link
                      >
                    </li>
                  </ul>
                </li>
                <!--<li><a href="javascript:void(0);" title="CMI Birmingham">Birmingham</a></li>-->
              </ul>
            </li>
            <li>
              <router-link to="/" :exact="true">Home</router-link>
            </li>
            <li>
              <router-link to="/about">About us</router-link>
            </li>
            <li>
              <a href="javascript:void(0);" title>Media</a>
              <ul>
                <li>
                  <router-link to="/watch-live">Watch Live</router-link>
                </li>
                <li>
                  <router-link to="/shop-products">Audio</router-link>
                </li>
              </ul>
            </li>
            <li>
              <router-link to="/donate">Donate</router-link>
            </li>
            <li>
              <a href="#contact">Contact</a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <!--- HEADER -->
    <div class="responsive-header">
      <div class="responsive-prayer">
        <p>Every Friday @11:00pm to 01:00am: Marathon Prayers</p>
        <ul class="headercounter">
          <li>
            <span class="days">00</span>
            <p class="days_ref">DAYS</p>
          </li>
          <li>
            <span class="hours">00</span>
            <p class="hours_ref">HOURS</p>
          </li>
          <li>
            <span class="minutes">00</span>
            <p class="minutes_ref">MINTS</p>
          </li>
          <li>
            <span class="seconds">00</span>
            <p class="seconds_ref">SECS</p>
          </li>
        </ul>
      </div>
      <!-- Responsive Prayer -->
      <div class="responsive-contact">
        <span>
          <p class="responsive-phone">
            <i class="fa fa-phone"></i> Mobile: 07723 363 184
          </p>
          <p class="responsive-mail">
            <i class="fa fa-envelope"></i> info@christlifefaithministries.org
          </p>
        </span>
        <a class="phone-btn active" href="#" title>
          <i class="fa fa-phone"></i>
        </a>
        <a class="mail-btn" href="#" title>
          <i class="fa fa-envelope"></i>
        </a>
      </div>
      <!-- Responsive Contact -->
      <div class="responsive-extras">
        <div class="responsive-social">
          <a
            title="CHRISTLIFE FAITH MINISTRIES Facebook page"
            href="https://www.facebook.com/christlifefaithministries.org"
            target="_blank"
          >
            <i class="fa fa-facebook"></i>
          </a>
          <a
            title="CHRISTLIFE FAITH MINISTRIES YouTube"
            href="https://www.youtube.com/@christlifefaithministriesc5100/streams"
            target="_blank"
          >
            <i class="fa fa-youtube"></i>
          </a>
          <!-- <a href="javascript:void(0);" title>
            <i class="fa fa-google-plus"></i>
          </a>
          <a href="javascript:void(0);" title>
            <i class="fa fa-linkedin"></i>
          </a> -->
        </div>
        <!-- Responsive Social -->
        <!-- <div @click="redirectToShop" class="responsive-cart">
          <i class="fa fa-shopping-cart"></i>
          {{ basketCount }} item(s) -
          <span>$ {{ basketTotal }}</span>
        </div> -->
      </div>
      <!-- Responsive Extras -->
      <div class="responisve-bar">
        <div class="responsive-logo">
          <router-link to="/" :exact="true">
            <img
              src="/dist/assets/logos/cfmchurch_logo_80x80_001.png"
              alt="CHRISTLIFE FAITH MINISTRIES LOGO"
            />
          </router-link>
        </div>
        <span class="responsive-btn">
          <i class="fa fa-list"></i>
        </span>
      </div>
    </div>
    <!-- Responsive Header -->
    <div class="responsive-menu">
      <ul>
        <li
          v-if="isCoventryAdmin || isLeicesterAdmin"
          class="menu-item-has-children"
        >
          <a href="javascript:void(0);" title>Admin</a>
          <ul>
            <li v-if="isLeicesterAdmin" class="menu-item-has-children">
              <a href="javascript:void(0);" title>CFM-Leicester</a>
              <ul>
                <li>
                  <router-link to="/shop-products-admin"
                    >Cash Orders</router-link
                  >
                </li>
                <li>
                  <router-link to="/leicester-resources"
                    >Manage Products</router-link
                  >
                </li>
                <li>
                  <router-link to="/leicester-people"
                    >Manage People</router-link
                  >
                </li>
                <li>
                  <router-link to="/leicester-events"
                    >Manage Events</router-link
                  >
                </li>
                <li>
                  <router-link to="/leicester-addresses"
                    >Manage Addresses</router-link
                  >
                </li>
                <li>
                  <router-link to="/leicester-alerts"
                    >Information Alert</router-link
                  >
                </li>
                <li>
                  <router-link to="/donation-admin"
                    >Manage Donation Info</router-link
                  >
                </li>
              </ul>
            </li>
            <li v-if="isCoventryAdmin" class="menu-item-has-children">
              <a href="javascript:void(0);" title>Toronto</a>
              <ul>
                <li>
                  <router-link to="/toronto-resources"
                    >Manage Products</router-link
                  >
                </li>
                <li>
                  <router-link to="/toronto-people">Manage People</router-link>
                </li>
                <li>
                  <router-link to="/toronto-events">Manage Events</router-link>
                </li>
                <li>
                  <router-link to="/toronto-addresses"
                    >Manage Addresses</router-link
                  >
                </li>
                <li>
                  <router-link to="/toronto-alerts"
                    >Information Alert</router-link
                  >
                </li>
              </ul>
            </li>
            <!--<li><a href="javascript:void(0);" title="CMI Birmingham">Birmingham</a></li>-->
          </ul>
        </li>
        <li>
          <router-link to="/" :exact="true">Home</router-link>
        </li>
        <li>
          <router-link to="/about">About us</router-link>
        </li>
        <li class="menu-item-has-children">
          <a href="javascript:void(0);" title>Media</a>
          <ul>
            <li>
              <router-link to="/watch-live">Watch Live</router-link>
            </li>
            <li>
              <router-link to="/shop-products">Audio</router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link to="/donate">Donate</router-link>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
    </div>
    <!-- Responsive Menu -->
    <router-view></router-view>

    <div class="bottom-footer">
      <div class="container">
        <p class="cmi-dev-contact">
          For your software needs contact
          <span style="color:#B6B9BF">programmer@softmighty.com</span> :
          mobile-apps, web-apps, websites, data-driven apps, consultancy and IT
          Strategy advisory services.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
moment.suppressDeprecationWarnings = true;
export default {
  name: "App",
  data() {
    return {};
  },
  methods: {
    ...mapActions(["handleAuthenticationRedirect"]),
    redirectToShop: function() {
      if (this.$route.name != "shop-products") {
        this.$router.push("/shop-products");
      }
    },
    getCountDownDate: function() {
      let date = new Date();
      while (date.getDay() !== 5) {
        //every Friday
        date.setDate(date.getDate() + 1);
      }
      let tempDate = moment(
        `${date.getMonth() +
          1}/${date.getDate()}/${date.getFullYear()} 23:00:00`
      ).add(date.getTimezoneOffset() / 60, "hours"); //adjust for timezone and UK +- 1 hour

      let tempDateDiff = moment().diff(tempDate, "hours");

      if (tempDateDiff >= 1 && tempDateDiff < 2) {
        return null;
      } else {
        return tempDate.toString();
      }
    },
    setCountDownDate: function() {
      window.$(".headercounter").downCount({
        date: this.getCountDownDate()
      });
    }
  },
  computed: {
    ...mapGetters([
      "isCoventryAdmin",
      "isLeicesterAdmin",
      "basketCount",
      "basketTotal"
    ])
  },
  mounted() {
    this.setCountDownDate();
    // Redirect: once login is successful and redirects with tokens, call Graph API
    this.$msalInstance
      .handleRedirectPromise()
      .then(response => {
        // console.log("Hello 1");
        // console.log(response);
        this.handleAuthenticationRedirect({ vm: this, response });
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>
